var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"orange"},[_vm._v("倒计时:"+_vm._s(_vm.time))])
}
var staticRenderFns = []

export { render, staticRenderFns }